import React, { useEffect, useState } from "react";
import ClickAwayListener from "react-click-away-listener";
import { useTranslation } from "react-i18next";
import InfiniteScroll from "react-infinite-scroll-component";
import { useDispatch, useSelector } from "react-redux";
import { Avatar, Badge, List, Popover, Skeleton, Space } from "antd";
import { BellIcon, NotificationTextIcon } from "assets/icons";
import moment from "moment/moment";
import {
  fetchNotificationPaging,
  fetchRealTimeMessagePaging,
  getNotificationCount,
  getNotificationList,
  reduceReadAllNotifications,
  reduceReadNotification,
  reduceUnReadNotification,
  resetRealTimeNotification,
} from "stores/slices/notification";

import AppButton from "components/button";
import ModalForm from "components/forms/components/modalForm";

import styles from "../styles.module.scss";

const contentStyle = {
  height: "250px",
  overflowY: "auto",
  color: "black",
  background: "#fff",
};
const Notification = props => {
  const { userId, timezone, role, userType } = props;

  const dispatch = useDispatch();
  const { t } = useTranslation();

  const notificationCount = useSelector(getNotificationCount);
  const realData = useSelector(getNotificationList);

  const [count, setCount] = useState(notificationCount);
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);

  const [hasMore, setHasMore] = useState(false);
  const [queries, setQueries] = useState({
    pageNumber: 1,
    pageSize: 5,
    type: "NOTICE",
  });

  const [newNotice, setNewNotice] = useState([]);
  const [listNotice, setListNotice] = useState([]);
  const [totalPages, setTotalPages] = useState(0);

  const [selectedNotice, setSelectedNotice] = useState();
  const [isOpenModalNotice, setIsOpenModalNotice] = useState(false);

  // useEffect(() => {
  //   role &&
  //     fetchMoreData({
  //       pageNumber: 1,
  //       pageSize: 5,
  //       type: "NOTICE",
  //     });
  // }, []);

  useEffect(() => {
    if (userId) {
      role && dispatch(fetchRealTimeMessagePaging({ userId: userId }));
      role &&
        fetchMoreData({
          pageNumber: 1,
          pageSize: 5,
          type: "NOTICE",
        });
    }
  }, [role]);

  useEffect(() => {
    setCount(notificationCount);
  }, [notificationCount]);

  useEffect(() => {
    if (realData.length > 0) {
      setNewNotice(realData);
      dispatch(reduceUnReadNotification({ type: "NOTICE" }));
    }
  }, [realData]);

  useEffect(() => {
    if (newNotice) {
      setData([...newNotice, ...data]);
    }
  }, [newNotice]);

  const removeDuplicates = arr => {
    return arr.filter(
      (ele, ind) => ind === arr.findIndex(elem => elem.id === ele.id)
    );
  };

  const _handleClick = async () => {
    if (isOpen) {
      setListNotice([]);
    }
    if (role) {
      // setHasMore(true);
      setIsOpen(!isOpen);
      fetchMoreData({
        ...queries,
        // pageNumber: 1,
        type: "NOTICE",
      });
    }
    setIsOpen(!isOpen);
  };

  const _handleClose = async () => {
    setIsOpen(false);
    setListNotice([]);
  };

  const handleOpenPopup = async record => {
    // openNotification(record);
    setSelectedNotice(record);
    setListNotice([...listNotice, record]);
    let newList = [...data];
    newList = data.map(content => {
      if (content.id === record.id) {
        const newContent = {
          ...content,
          status: "READ",
        };
        return newContent;
      } else {
        return content;
      }
    });
    setIsOpen(false);
    setIsOpenModalNotice(true);
    setData(newList);
    const duplicate = listNotice.filter(item => item.id === data.id);
    if (duplicate.length === 0) {
      await dispatch(
        reduceReadNotification({
          id: record.id,
          request: queries,
        })
      );
      dispatch(resetRealTimeNotification());
    } else {
      setListNotice(listNotice.filter(item => item.id !== record.id && item));
    }
  };

  const fetchMoreData = async request => {
    const newRequest = {
      pageNumber: request.pageNumber,
      pageSize: request.pageSize,
      type: request.type,
    };
    if (totalPages > 0 && request.pageNumber > totalPages) {
      setHasMore(false);
      return;
    }
    setIsLoading(true);
    setHasMore(false);
    const { payload } = await dispatch(fetchNotificationPaging(newRequest));
    if (payload && typeof payload !== "string") {
      let newList = [];
      if (request.isReadAll) {
        newList = removeDuplicates([...payload.content, ...data]);
      } else {
        newList = removeDuplicates([...data, ...payload.content]);
      }
      // const newList = removeDuplicates([...data, ...payload.content]);
      setData(newList);
      setQueries(newRequest);
      setTotalPages(payload.totalPages);
    }
    setIsLoading(false);
  };

  const formatTimeAgo = sentTime => {
    if (typeof sentTime === "object") {
      const date = moment(sentTime.seconds * 1000)
        ?.locale("en-au")
        ?.tz(timezone ? timezone : moment.tz.guess())
        ?.fromNow();
      return date;
    } else {
      const date = moment(sentTime)
        ?.locale("en-au")
        ?.tz(timezone ? timezone : moment.tz.guess())
        ?.fromNow();
      return date;
    }
  };

  const _handleReadAllNotifications = async () => {
    const result = await dispatch(reduceReadAllNotifications());
    const { payload } = result;
    if (payload === "ok") {
      dispatch(reduceUnReadNotification({ type: "NOTICE" }));
      setData(
        data.map(item => {
          if (item.status === "UNREAD") {
            item.status = "READ";
          }
          return item;
        })
      );
      fetchMoreData({ ...queries, type: "NOTICE", isReadAll: true });
    }
  };

  const handleScroll = eve => {
    const clientHeight = eve.target.clientHeight;
    const scrollTop = eve.target.scrollTop;
    const scrollHeight = eve.target.scrollHeight;
    if (
      clientHeight + 20 - (scrollHeight - scrollTop) > 0 &&
      queries.pageNumber <= totalPages
    ) {
      setHasMore(true);
    }
  };

  const renderNotification = () => {
    return (
      <div style={{ width: 350 }}>
        <Space
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h2>{t("title.notifications")}</h2>
          <div style={{ cursor: "pointer" }}>
            <a onClick={() => _handleReadAllNotifications()}>
              {t("text.markAllAsRead")}
            </a>
          </div>
        </Space>
        <div id="scrollToDiv">
          <InfiniteScroll
            dataLength={data.length}
            next={
              hasMore &&
              fetchMoreData({
                pageNumber: queries.pageNumber + 1,
                pageSize: 5,
                type: "NOTICE",
              })
            }
            hasMore={hasMore}
            loader={
              isLoading && (
                <Skeleton
                  avatar
                  paragraph={{
                    rows: 1,
                  }}
                  active
                />
              )
            }
            height={400}
            scrollThreshold={390}
            endMessage={
              isLoading ? (
                <Skeleton
                  avatar
                  paragraph={{
                    rows: 1,
                  }}
                  active
                />
              ) : (
                <></>
              )
            }
            onScroll={handleScroll}
          >
            <List
              dataSource={data}
              renderItem={item => (
                <List.Item
                  key={item.id}
                  onClick={() => handleOpenPopup(item)}
                  style={{
                    cursor: "pointer",
                    opacity: item.status === "READ" ? 0.7 : 1,
                  }}
                >
                  <List.Item.Meta
                    avatar={<NotificationTextIcon />}
                    title={"New Notice"}
                    description={
                      <div>
                        <div
                          className={styles.text2lines}
                          style={{
                            color: "#000000",
                          }}
                        >
                          <div
                            dangerouslySetInnerHTML={{
                              __html: item?.body,
                            }}
                          />
                        </div>
                        {item.status === "UNREAD" ? (
                          <a>{formatTimeAgo(item?.sentTime)}</a>
                        ) : (
                          <span>{formatTimeAgo(item?.sentTime)}</span>
                        )}
                      </div>
                    }
                  />
                  <div>
                    {item.status === "UNREAD" && (
                      <div style={{ textAlign: "end" }}>
                        <span
                          style={{
                            height: "10px",
                            width: "10px",
                            backgroundColor: "#0866ff",
                            borderRadius: "100%",
                            display: "inline-block",
                          }}
                        ></span>
                      </div>
                    )}
                  </div>
                </List.Item>
              )}
            />
          </InfiniteScroll>
        </div>
      </div>
    );
  };

  const handleTitleNotice = () => {
    return (
      <div style={{ textAlign: "center" }}>
        <span style={{ fontSize: 16 }}>{t("noticeBoard.notice")}</span>
        <hr />
      </div>
    );
  };

  return (
    <React.Fragment>
      <ClickAwayListener onClickAway={_handleClose}>
        <div style={{ lineHeight: "normal" }}>
          <Popover
            open={isOpen}
            content={renderNotification}
            style={{ width: 250, lineHeight: "" }}
          >
            <Badge count={count}>
              <Avatar
                className={styles.headerIcon}
                style={{
                  opacity: !role ? 0.5 : 1,
                  cursor: !role ? "not-allowed" : "",
                }}
                icon={<BellIcon />}
                onClick={() =>
                  userType !== "SUPER_ADMIN" && role !== null && _handleClick()
                }
              />
            </Badge>
          </Popover>
        </div>
      </ClickAwayListener>
      <ModalForm
        isOpen={isOpenModalNotice}
        title={handleTitleNotice()}
        onCancel={() => setIsOpenModalNotice(false)}
        // footer={false}
        maskClosable={false}
        footer={[
          <AppButton
            key="button"
            label={t("button.close")}
            color={"grey"}
            htmlType="button"
            size={"medium"}
            onClick={() => {
              setIsOpenModalNotice(false);
            }}
          />,
        ]}
      >
        {selectedNotice && (
          <div style={{ marginLeft: 10 }}>
            <div
              className="quill hiddenToolbar customScrollbar borderNone"
              style={contentStyle}
              dangerouslySetInnerHTML={{
                __html: selectedNotice?.body,
              }}
            />
          </div>
        )}
      </ModalForm>
    </React.Fragment>
  );
};

export default Notification;
